module.exports = __webpack_public_path__ + "media/assets/images/v-gray-eb7fe67bbad1d62f8e965d18f024b0e0.svg";